import { render, staticRenderFns } from "./resume-header-dialog.vue?vue&type=template&id=c50ba216&scoped=true"
import script from "./resume-header-dialog.vue?vue&type=script&lang=js"
export * from "./resume-header-dialog.vue?vue&type=script&lang=js"
import style0 from "./resume-header-dialog.vue?vue&type=style&index=0&id=c50ba216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50ba216",
  null
  
)

export default component.exports